import config from '@/config'

export default {
  combine: {
    confirm_password: "Konfirmasi @:ui.password",
    change_password: "Ubah @:ui.password",
    old_password: "Lama @:ui.password",
    new_password: "@:ui.new @:ui.password",
    account_status: "@:ui.account @:ui.status",
    confirm_security_code: "Konfirmasi @:ui.security_code",
    first_time_login: "Login Pertama Kali",
    security_authentication: "Otentikasi Keamanan",
    update_security: "Perbarui Keamanan",
    disable_security: "Nonaktifkan Keamanan",
    add_operator: "Tambah Operator",
    add_account: "Tambah Akun",
    add_sub_account: "Tambah Sub Akun",
    edit_operator: "Edit Operator",
    edit_account: "Edit Akun",
    edit_member: "Edit Anggota",
    approve_ticket: "Setujui Tiket",
    reject_ticket: "Tolak Tiket",
    add_bank_account: "Tambah Rekening Bank",
    edit_bank_account: "Edit Rekening Bank",
    reset_threshold: "Atur Ulang Ambang Batas",
    adjust_balance: "Sesuaikan Saldo",
    adjust_member: "Sesuaikan Anggota",
    configure_bank_setting: "Konfigurasi Pengaturan Bank",
    account_setup: "Pengaturan Rekening",
    bank_transfer: "Transfer Bank",
    edit_bank_member: "Edit Anggota Bank",
    view_ticket: "Lihat Tiket",
    edit_ticket: "Edit Tiket",
    edit_vip: "Edit VIP",
    report: "Laporan",
    knock_off_promo: "Hentikan Promosi",
    edit_authority: "Edit Otoritas",
    reset_password: "Atur Ulang Kata Sandi",
    update_password: "Perbarui Kata Sandi",
    member_summary: "Ringkasan Anggota",
    reply_review: "Balas Ulasan",
    edit_affiliate: "Edit Afiliasi",
    edit_bank_affiliate: "Edit Afiliasi Bank",
    approve_affiliate_ticket: "Setujui Tiket Afiliasi",
    check_free_spin: "Periksa Putaran Gratis",
    reject_affiliate_ticket: "Tolak Tiket Afiliasi",
    wallet_adjust: "Sesuaikan Dompet",
    update_comm_package: "Perbarui Paket Comm",
    approve_affiliate: "Setujui Afiliasi",
    sub_acc_detail_affiliate: "Detail Sub Akun Afiliasi",
    get_tac: "Dapatkan OTP",
    add_coupon: "Tambahkan Kupon",
    update_coupon: "Perbarui Kupon",
    issue_free_spin: "Keluarkan Putaran Gratis",
    get_bank_tac: "Dapatkan OTP Bank",
    update_global_setting: "Perbarui Pengaturan Global",
    add_platform: "Tambah Platform",
    edit_platform: "Edit Platform",
    add_bank_group: "Tambahkan Grup Bank",
    edit_bank_group: "Edit Grup Bank",
    update_maintenance_schedule: "Perbarui Jadwal Pemeliharaan",
    add_withdrawal_limit: "Tambahkan Batas Penarikan",
    edit_withdrawal_limit: "Edit Batas Penarikan",
    add_campaign: "Tambah Kampanye",
    edit_campaign: "Edit Kampanye",
    add_promo_group: "Tambah Grup Promosi",
    edit_promo_group: "Edit Grup Promosi",
    update_team: "Tim Pembaruan",
    update_result: "Perbarui Hasil",
    insert_result: "Sisipkan Hasil",
    bet_list: "Daftar Taruhan",
    result_list: "Daftar Hasil",
    add_promo: "Tambahkan Promosi",
    raise_deposit_ticket: "Naikkan Tiket Deposit",
    bank_adjust: "Sesuaikan Bank",
    promo_member_assign: "Tetapkan Anggota Promosi",
    bonus_issue: "Masalah Bonus",
    update_vip: "Perbarui VIP",
    update_member_profile: "Perbarui Profil Anggota",
    change_withdrawal_limit: "Ubah Batas Penarikan",
    change_bank_group: "Ubah Grup Bank",
    change_promotion_group: "Ubah Grup Promosi",
    promotion_signup: "Pendaftaran Promosi",
    edit_promo_signup: "Edit Pendaftaran Promosi",
    update_provider_bet_limit: "Perbarui Batas Taruhan Penyedia",
    update_bet_limit: "Perbarui Batas Taruhan",
    update_member_bet_limit: "Perbarui Batas Taruhan Anggota",
    edit_bank_account_group: "Edit Grup Rekening Bank",
    redeposit_ticket: "Setor Ulang Tiket",
    edit_promotion_group: "Edit Grup Promosi",
    edit_promotion_group_norm: "Kelola Promosi Dalam Grup",
    get_inbox_list: "Dapatkan Daftar Kotak Masuk",
    view_result_changes_detail: "Lihat Detail Perubahan Hasil",
    edit_promotion_signup: "Edit Pendaftaran Promosi",
    edit_bet_limit: "Edit Batas Taruhan",
    edit_provider_game_off: "Edit Permainan Penyedia Tidak Aktif",
    edit_provider_rtp: "Edit RTP Penyedia",
    get_rebate: "Dapatkan Rabat",
    get_recent_deposit: "Dapatkan Setoran Terbaru",
    add_survey: "Tambahkan Survei",
    add_announcement_banner: "Tambahkan Banner Pengumuman",
    edit_announcement_banner: "Edit Banner Pengumuman",
    move_announcement_banner: "Pindahkan Banner Pengumuman",
    add_promotion_banner: "Tambah Banner Promosi",
    edit_promotion_banner: "Edit Banner Promosi",
    move_promotion_banner: "Pindahkan Spanduk Promosi",
    add_slide_banner: "Tambah Spanduk Slide",
    edit_slide_banner: "Edit Slide Banner",
    move_slide_banner: "Pindahkan Slide Banner",
    add_seo_page: "Tambahkan Halaman SEO",
    edit_seo_page: "Edit Halaman SEO",
    clear_outstanding: "Hapus Outstanding",
    add_ip_whitelist: "Tambahkan Daftar Putih IP",
    edit_payment_option_provider: "Edit Penyedia Opsi Pembayaran",
    bonus_issue_bulk: "Masalah Bonus Massal",
    edit_bank_member_ewallet: "Edit Anggota Bank (E-Wallet)",
    redeposit: "Deposit Ulang",
    reject_approved_ticket: "Tolak Tiket yang Disetujui",
    audit_ticket: "Audit Ticket",
    review_ticket: "Tinjau Tiket",
    edit_promotion_group_norm_seq: "Kelola Urutan Promosi Dalam Grup",
    edit_promo_provider_list: "Edit Daftar Penyedia Promosi",
    edit_promo_payment_option: "Edit Opsi Pembayaran Promosi",
    edit_campaign_provider_list: "Edit Daftar Penyedia Kampanye",
    update_global_setting_affiliate: "Perbarui Pengaturan Global (Afiliasi)",
    update_comm: "Perbarui Komisi",
    update_carry_over: "Perbarui Carry Over",
    update_settlement_type: "Perbarui Jenis Penyelesaian",
    review_affiliate_ticket: "Tinjau Tiket Afiliasi",
    audit_affiliate_ticket: "Audit Tiket Afiliasi",
    get_tac_affiliate: "Dapatkan OTP (Afiliasi)",
    raise_deposit_ticket_gateway: "Naikkan Tiket Deposit (Gateway)",
    member_details: "Detail Anggota",
    direct_audit_ticket: "Audit Tiket (Langsung)",
    get_rollback_detail: "Dapatkan Detail Rollback",
    get_reject_detail: "Dapatkan Detail Penolakan",
    manual_approve_ticket: "Setujui Tiket (Manual)",
    add_label: "Tambah Label",
    edit_label: "Edit Label",
    set_bank_default_sender: "Atur Pengirim Default Bank",
    rollback_processing_ticket: "Kembalikan Tiket Pemrosesan",
    update_iframe_url: "Perbarui URL Iframe",
    edit_exchange_rate: "Edit Nilai Tukar",
    add_vip: "Tambahkan VIP",
    add_turnover_tier: "Tambahkan Tingkat Omset",
    edit_turnover_tier: "Edit Tingkat Omset",
    get_member_label_list: "Daftar Label Anggota",
    add_rescue_fund: "Tambahkan Dana Penyelamatan",
    get_custom_member_list: "Daftar Anggota Khusus",
    get_rescue_fund_provider: "Dapatkan Penyedia Dana Penyelamatan",
    add_game_exclude: "Tambahkan Pengecualian Game",
    domain_assign: "Tetapkan Anggota Domain",
    domain_custom_add_assign: "Tambah Domain",
    add_domain_batch: "Tambahkan Domain (Batch)",
    update_payment_provider_vip: "Perbarui Vip Penyedia Pembayaran",
    update_campaign: "Perbarui Kampanye",
    purchase_domain: "Beli Domain",
    apply_domain: "Terapkan Domain",
    edit_access_control: "Edit Kontrol Akses",
    edit_access_auto: "Edit Penugasan Otomatis",
    add_domain: "Tambah domain",
    operator_balance_topup: "Isi Ulang Saldo",
    operator_wallet_adjust: "Sesuaikan Dompet Operator",
    update_payment_provider_desc: "Perbarui Deskripsi Penyedia Pembayaran",
    update_payment_option_desc: "Perbarui Deskripsi Opsi Pembayaran",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    edit_profile: "@:ui.edit @:ui.profile",
    update_setting: "@:ui.update @:ui.setting",
    edit_domain: "@:ui.edit @:ui.domain",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Setup Logo",
    operator_security_deposit_adjust: "Sesuaikan Dana Jaminan",
    manual_process: "Proses Manual",
    update_permitted_amount: "Perbarui Jumlah yang Diizinkan",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    edit_provider: "@:ui.edit_provider",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    add_reward: "@:ui.add @:ui.reward",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
  },
  short: {
    deposit_amount: "Dep Amt",
    base_amount: "Base Amt",
    bonus_amount: "Bonus Amt",
    target_amount: "Trgt Amt",
    accumulate_amount: "Acc Amt",
    knockoff_by: "K.O Oleh",
    knockoff_date: "Tanggal K.O",
    incoming_threshold: "IN THRES",
    incoming_frequency: "IN FREQ",
    outgoing_threshold: "OUT THRES",
    outgoing_frequency: "OUT FREQ",
    account_balance: "ACC BAL",
    claim_type: "C.Type",
    bonus_rate: "B.Rate",
    max_bonus: "M.Bonus",
    rollover: "Rollover",
    criteria: "Kriteria",
    start_time: "S.Time",
    end_time: "E.Time",
    monday: "MON",
    tuesday: "TUE",
    wednesday: "RABU",
    thursday: "THU",
    friday: "JUMAT",
    saturday: "SAT",
    sunday: "MATAHARI",
    status: "Status",
    bonus_rate_percent: "B.Rate (%)",
    valid_turnover: "V.Turnover",
    deposit_count: "Dep Cnt",
    withdrawal_amount: "Wdw Amt",
    withdrawal_count: "Wdw Cnt",
    bonus_amount: "Jumlah Bonus",
    adjustment_amount: "Adj Amt",
    referee_count: "Wasit Cnt",
    signup_count: "Pendaftaran Cnt",
    verified_count: "Jumlah VRF",
    active_member: "Mbm Aktif",
    ftd_count: "FTD Cnt",
    ftd_amount: "FTD Amt",
    working_date: "Working DT",
    bet_count: "Taruhan Cnt",
    recipient_bank_id: "ID R.Bank",
    recipient_bank_acc_no: "Nomor Rekening Bank",
    recipient_bank_acc_holder: "Pemegang Rekening Bank R.Bank",
    sender_bank: "S.Bank",
    sender_bank_acc_no: "No. rekening bank",
    sender_bank_acc_holder: "Pemegang Rekening S.Bank",
    unique_login_count: "U.Login Cnt",
    unique_withdrawal_count: "U.Wdw Cnt",
    second_deposit_count: "S.Dep Cnt",
    reject_date: "R.Date",
    processing_date: "P.Date",
    deposit_withdrawal_different: "Dep Wdw Diff",
    external_id: "Ex. ID",
    draft_version: "Draft. Ver.",
    prod_version: "Prod. Ver.",
    purchased_date: "P. Date"
  },
  date_ranges: {
    0: "Hari ini",
    1: "Kemarin",
    2: "Bulan Ini",
    4: "Bulan lalu",
  },
  langList: {
    EN: "Bahasa Inggris",
    CN: "Bahasa Mandarin",
    PHP: "Filipina",
    esp: "Bahasa Spanyol"
  },
  cartStep: {
    SETUP: "SETUP",
    DOMAIN: "DOMAIN",
    THEME: "UI",
    THEME_COLOR: "WARNA TEMA",
    PAYMENT: "GATEWAY PEMBAYARAN",
    SUMMARY: "RINGKASAN",
    OPERATOR_INFO: "PENGATURAN OPERATOR"
  },
  menulist: {
    home: "Rumah",
    hot: "Permainan Panas",
    slot_game: "Permainan Slot",
    casino: "Kasino",
    sportsbook: "Buku Olahraga",
    fishing: "Memancing",
    lottery: "Lotere",
    poker: "Poker",
    hash_game: "Permainan Hash",
    sabong: "Sabong",
    promotion: "Promosi",
    review: "Ulasan",
    news: "Berita",
    live_stream: "Siaran Langsung",
    vip: "VIP",
    referral: "Rujukan",
    favourite: "Favorit",
    mission: "Misi (Permainan Mini)",
    spin: "Putar",
    leaderboard: "Papan Peringkat",
    account: "Akun",
    deposit: "Deposit",
    withdrawal: "Penarikan",
    bet_history: "Riwayat Taruhan",
    pending_status: "Status Tertunda",
    change_password: "Ubah Kata Sandi",
    profile: "Profil",
    banking_details: "Detail Perbankan",
    inbox: "Kotak Masuk",
    voucher: "Voucher",
    wallet: "Dompet",
    statement: "Pernyataan",
    download: "Unduh",
    game: "Permainan",
    special: "Khusus",
    misc: "Lain-lain",
    contact_us: "Hubungi Kami",
    e_sportsbook: "Buku Olahraga Elektronik",
    lotto: "Lotto",
    p2p: "P2P",
    other: "Lainnya",
    vip2: "VIP2",
    referral2: "Referensi2",
    event: "Acara",
    daily_reward: "Hadiah Harian",
    play2earn: "Mainkan 2 Hasilkan",
    redemption: "Penukaran",
    card_board: "Papan Kartu",
    lobby: "Lobi",
    in_house: "In House",
    transfer: "Transfer",
    horse_racing: "Pacuan Kuda",
    register: "Daftar",
    login: "Login",
    transaction_history: "Riwayat Transaksi",
    bingo: "Bingo",
    member: "Anggota",
    arcade: "Arkade",
    crash: "Roket Judi"
  },
  cartStatus: {
    ALL: "SEMUA",
    ACTIVE: "AKTIF",
    PENDING_PAYMENT: "PEMBAYARAN TERTUNDA",
    PURCHASED: "DIBELI",
    PENDING_SETUP: "PENYIAPAN YANG TERTUNDA",
    COMPLETED: "SELESAI",
    FAILED: "GAGAL",
    TIMEOUT: "WAKTU BERAKHIR",
    REJECTED: "DITOLAK"
  },

  ok: "OK",
  cancel: "Batal",
  login: "Masuk",
  logout: "Keluar",
  add: "Tambah",
  edit: "Edit",
  delete: "Hapus",
  refresh: "Refresh",
  action: "Tindakan",
  id: "ID",
  name: "Nama",
  all: "Semua",
  search: "Cari",
  remove: "Hapus",
  save: "Simpan",
  account: "Akun",
  settings: "Pengaturan",
  on: "AKTIF",
  off: "OFF",
  new: "Baru",
  clear: "Hapus",
  users: "Pengguna | Pengguna",
  username: "Nama pengguna",
  password: "Kata Sandi",
  created_on: "Buat Aktif",
  active: "Aktif",
  page_size: "Ukuran Halaman",
  status: "Status",
  fullname: "Nama Lengkap",
  result: "Hasil",
  version: "Versi",
  close: "Tutup",
  back: "Kembali",
  show: "Tampilkan",
  login_id: "ID Login",
  logs: "Log | Log",
  date_time: "Tanggal Waktu",
  ip_address: "Alamat IP",
  domain_name: "Nama Domain",
  browser_agent: "Agen Peramban",
  action_by: "Tindakan Oleh",
  details: "Detail",
  key: "Kunci | Kunci",
  value: "Nilai | Nilai",
  from: "Dari",
  to: "Kepada",
  type: "Jenis",
  criteria: "Kriteria",
  log: "Log",
  report: "Laporan",
  security_tag: "Tag Keamanan",
  security_code: "Kode Keamanan",
  submit: "Kirim",
  disable: "Nonaktifkan",
  operators: "Operator | Operator",
  members: "Anggota",
  account_id: "ID Akun",
  confirm_password: "Konfirmasi Kata Sandi",
  full_name: "Nama Lengkap",
  contact_phone: "Telepon Kontak",
  contact_email: "Email Kontak",
  dashboard: "Dasbor",
  sub_account: "Sub Akun",
  authority_option: "Opsi Otoritas",
  banks: "Bank | Bank",
  login_ip : "IP Login",
  block: "Blokir",
  profile_id: "ID Profil",
  suspend: "Tangguhkan",
  dob: "DOB",
  mail_address: "Alamat Surat",
  deposit: "Deposit",
  withdrawal: "Penarikan",
  rejected: "Ditolak",
  processed: "Diproses",
  pending: "Tertunda",
  member: "Anggota",
  amount: "Jumlah",
  bank_acc_no: "Nomor Rekening Bank",
  deposit_date: "Tanggal Deposit",
  deposit_method: "Metode Deposit",
  approve: "Setujui",
  reject: "Tolak",
  remark: "Keterangan",
  ticket_detail: "Detail Tiket",
  promo: "Promo",
  package: "Paket",
  created_date: "Tanggal Pembuatan",
  currency: "Mata Uang",
  bank_acc_holder: "Pemegang Rekening Bank",
  ref_no: "Nomor Referensi",
  vip: "VIP",
  requirement: "Persyaratan",
  modified_date: "Tanggal Modifikasi",
  modified_by: "Diubah Oleh",
  bank_member: "Anggota Bank",
  bank_operator: "Operator Bank",
  bank_name: "Nama Bank",
  bank_acc_type: "Jenis Rekening Bank",
  account_balance: "Saldo Rekening",
  threshold: "Ambang Batas",
  incoming: "Masuk",
  outgoing: "Keluar",
  frequency: "Frekuensi",
  reset_threshold: "Atur Ulang Ambang Batas",
  adjust_balance: "Sesuaikan Saldo",
  bank_from: "Bank Dari",
  bank_to: "Bank Ke",
  attachment: "Lampiran",
  sender_bank: "Bank Pengirim",
  sender_bank_acc_no: "Nomor Rekening Bank Pengirim",
  sender_bank_acc_holder: "Pemegang Rekening Bank Pengirim",
  audit: "Audit",
  action_status: "Status Tindakan",
  action_date: "Tanggal Tindakan",
  promotion: "Promosi",
  promo_id: "ID Promo",
  promo_name: "Nama Promo",
  package_id: "ID Paket",
  claim_type: "Jenis Klaim",
  bonus_rate: "Tingkat Bonus",
  max_bonus: "Bonus Maks",
  rollover: "Rollover",
  start_date: "Tanggal Mulai",
  end_date: "Tanggal Akhir",
  adj_amount: "Sesuaikan Jumlah",
  promotion_member: "Anggota Promosi",
  on_going: "Sedang Berjalan",
  knock_off: "Hentikan",
  all_ongoing: "Semua Sedang Berlangsung",
  deposit_amount: "Jumlah Deposit",
  base_amount: "Jumlah Dasar",
  bonus_amount: "Jumlah Bonus",
  target_amount: "Jumlah Target",
  claim_date: "Tanggal Klaim",
  accumulate_win: "Akumulasi Kemenangan",
  accumulate_turnover: "Akumulasi Omset",
  package: "Paket",
  bonus: "Bonus",
  bonus_log: "Catatan Bonus",
  member_id: "ID Anggota",
  before_balance: "Sebelum Saldo",
  transfer_amount: "Jumlah Transfer",
  after_balance: "Setelah Saldo",
  created_by: "Dibuat Oleh",
  bonus_name: "Nama Bonus",
  bonus_desc: "Deskripsi Bonus",
  bonus_type: "Jenis Bonus",
  add_promo: "Tambahkan Promosi",
  bonus_value: "Nilai Bonus",
  attach_promo: "Lampirkan Promosi",
  daily_statement: "Laporan Harian",
  working_date: "Tanggal Kerja",
  opening_balance: "Saldo Pembukaan",
  turnover: "Omset",
  valid_turnover: "Omset yang Valid",
  winlose: "MenangKalah",
  withdrawal_amount: "Jumlah Penarikan",
  closing_balance: "Saldo Penutupan",
  sub_total: "Sub Total",
  grand_total: "Total Keseluruhan",
  daily_winlose: "Kemenangan Harian",
  game_result_slots: "Hasil Permainan (Slot)",
  game_result_livecasino: "Hasil Permainan (Livecasino)",
  game_result_rebate: "Hasil Permainan (Rabat)",
  game_result_sportsbook: "Hasil Permainan (Sportsbook)",
  game_result_cockfight: "Hasil Permainan (Sabung Ayam)",
  game_result_rescue: "Hasil Permainan (Penyelamatan)",
  game_result: "Hasil Permainan",
  bet_count: "Hitungan Taruhan",
  result_id: "ID Hasil",
  bet_time: "Waktu Taruhan",
  payout: "Pembayaran",
  game_type: "Jenis Permainan",
  game_name: "Nama Permainan",
  game_provider: "Penyedia Permainan",
  reset: "Atur Ulang",
  mode: "Mode",
  balance: "Balance",
  min_bal_knock_off_promo: "Min Bal. (Untuk mematikan promosi secara otomatis)",
  social_account: "Akun Sosial",
  wechat: "WeChat",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  login_log: "Log Masuk",
  platform: "Platform",
  bank_statement: "Laporan Bank",
  transfer_date: "Tanggal Transfer",
  detail: "Detail",
  date: "Tanggal",
  transfer_list: "Daftar Transfer",
  credit: "Kredit",
  debit: "Debit",
  month: "Bulan",
  unblock: "Buka Blokir",
  unblock_member: "Buka Blokir Anggota",
  unblock_operator: "Buka Blokir Operator",
  after_balance: "Setelah Saldo",
  referrer_id: "ID Perujuk",
  referrer_code: "Kode Perujuk",
  referral_code: "Kode Referensi",
  bonus_and_adjustment: "Bonus & Penyesuaian",
  adjustment: "Penyesuaian",
  incoming_amount_threshold: "Ambang Batas Jumlah Masuk",
  outgoing_amount_threshold: "Ambang Batas Jumlah Keluar",
  knock_off_by: "Knock Off By",
  knock_off_date: "Tanggal Knock Off",
  accumulate_amount: "Jumlah Akumulasi",
  total_turnover: "Total Turnover",
  total_winlose: "Total Kemenangan",
  total_deposit: "Total Deposit",
  total_member: "Total Anggota",
  active_player: "Pemain Aktif",
  top_winner: "Pemenang Teratas",
  top_loser: "Pecundang Teratas",
  winner: "Pemenang",
  loser: "Pecundang",
  deposit_count: "Jumlah Deposit",
  withdrawal_count: "Hitungan Penarikan",
  bet_count: "Jumlah Taruhan",
  alert: "Peringatan",
  incoming_threshold: "Ambang Batas Masuk",
  incoming_frequency: "Frekuensi Masuk",
  outgoing_threshold: "Ambang Batas Keluar",
  outgoing_frequency: "Frekuensi Keluar",
  reset_password: "Atur Ulang Kata Sandi",
  authority_option: "Opsi Otoritas",
  transfer: "Transfer",
  company_bank: "Bank Perusahaan",
  company_bank_acc_no: "Nomor Rekening Bank Perusahaan",
  company_bank_acc_holder: "Pemegang Rekening Bank Perusahaan",
  registered_member: "Anggota Terdaftar",
  promotion_report: "Laporan Promosi",
  deposited_member: "Anggota yang Menyetor",
  referred_member: "Anggota yang Direkomendasikan",
  validated_on: "Tervalidasi Pada",
  first_deposit: "Deposit Pertama",
  nickname: "Nama Panggilan",
  reward: "Hadiah",
  inbox: "Kotak Masuk",
  manual_bonus: "Bonus Manual",
  review: "Ulasan | Ulasan",
  reviews: "Ulasan",
  review_list: "Daftar Ulasan",
  review_detail: "Detail Ulasan",
  reply_review: "Balas Ulasan",
  comment: "Komentar",
  reply: "Balas",
  recipient_no: "Nomor Penerima",
  question : "Pertanyaan",
  rating: "Peringkat",
  content: "Konten",
  image: "Gambar",
  monthly_rating: "Peringkat Bulanan",
  affiliate: "Afiliasi",
  affiliate_list: "Daftar Afiliasi",
  affiliate_code: "Kode Afiliasi",
  approved_by: "Disetujui Oleh",
  approved_date: "Tanggal Disetujui",
  bank_affiliate: "Afiliasi Bank",
  bank_id: "ID Bank",
  ticket_detail_affiliate: "Detail Tiket Afiliasi",
  pending_application: "Aplikasi Tertunda",
  pending_withdrawal: "Penarikan Tertunda & Tinjau Penarikan",
  pending_review_withdrawal: "Penarikan Tertunda & Tinjau Penarikan",
  unblock_affiliate: "Buka Blokir Afiliasi",
  wallet_adjust: "Sesuaikan Dompet",
  comm_package: "Paket Komunikasi",
  affiliate_id: "ID Afiliasi",
  sub_account_detail: "Detail Sub Akun",
  comm_log: "Catatan Komunikasi",
  earning_breakdown: "Perincian Penghasilan",
  daily_winlose_member: "Anggota Winlose Harian",
  total_revenue: "Total Pendapatan",
  player_id: "ID Pemain",
  daily_winlose_affiliate: "Winlose Harian (Afiliasi)",
  daily_deposit_affiliate: "Setoran Harian (Afiliasi)",
  comm_package_old: "Paket Comm Lama",
  comm_package_new: "Paket Komunikasi Baru",
  export_excel: "Ekspor Excel",
  get_tac: "Dapatkan OTP",
  tac_code: "Kode OTP",
  expiry_date: "Tanggal Kedaluwarsa",
  inactive: "Tidak Aktif",
  player_list: "Daftar Pemain",
  last_deposit_date: "Tanggal Setoran Terakhir",
  last_deposit_amount: "Jumlah Setoran Terakhir",
  never_deposited: "Tidak Pernah Menyetor",
  coupon: "Kupon",
  allocated: "Dialokasikan",
  claimed: "Diklaim",
  approved: "Disetujui",
  coupon_code: "Kode Kupon",
  coupon_quota: "Kuota Kupon",
  current_allocated: "Dialokasikan Saat Ini",
  new_allocated: "Alokasi Baru",
  update : "Perbarui",
  tac_validated: "OTP Tervalidasi",
  copy: "Salinan",
  bonus_rate_percent : "Tingkat Bonus (%)",
  coupon_desc: "Deskripsi Kupon",
  both: "Keduanya",
  issue_free_spin: "Terbitkan Putaran Gratis",
  game: "Permainan",
  max_win_amount: "Jumlah Kemenangan Maks",
  utm_list: "Daftar UTM",
  search_by_member: "Cari Berdasarkan Anggota",
  source: "Sumber",
  campaign: "Kampanye",
  deposited: "Deposit",
  search_by_id: "Cari Berdasarkan ID",
  get_bank_tac: "Dapatkan OTP Bank",
  bank_statement_daily: "Laporan Bank (Harian)",
  transfer_type: "Jenis Transfer",
  audit_freebies_list: "Daftar Gratis Audit",
  acknowledge: "Akui",
  submit_acknowledgement: "Kirim Pengakuan",
  is_ack: "Apakah Ack",
  yes: "Ya",
  no: "Tidak",
  audit_rescue_fund_list: "Daftar Dana Penyelamatan Audit",
  global_setting: "Pengaturan Global",
  signup_ip: "IP Pendaftaran",
  last_login_ip: "IP Login Terakhir",
  last_login_time: "Waktu Login Terakhir",
  link: "Tautan",
  is_default: "Apakah Default",
  is_public: "Bersifat Publik",
  bank_group: "Grup Bank",
  set_default: "Set Default",
  group_id: "ID Grup",
  group_name: "Nama Grup",
  provider_maintenance: "Pemeliharaan Penyedia",
  provider_code: "Kode Penyedia",
  provider_name: "Nama Penyedia",
  withdrawal_limit: "Batas Penarikan",
  limit_id: "ID Batas",
  limit_name: "Nama Limit",
  daily_amount: "Jumlah Harian",
  daily_frequency: "Frekuensi Harian",
  promotion_id: "ID Promosi",
  promotion_name: "Nama Promosi",
  withhold_bonus: "Tahan Bonus",
  withhold_amount: "Jumlah Pemotongan",
  withhold_amt: "Tarik Amt",
  max_withdraw_amt: "Jumlah Penarikan Maksimal",
  max_withdraw_amount: "Jumlah Penarikan Maksimal",
  monday: "Senin",
  tuesday: "Selasa",
  wednesday: "Rabu",
  thursday: "Kamis",
  friday: "Jumat",
  saturday: "Sabtu",
  sunday: "Minggu",
  start_time: "Waktu Mulai",
  end_time: "Waktu Akhir",
  day: "Hari | Hari",
  coupon_status: "Status Kupon",
  campaign_id: "ID Kampanye",
  campaign_name: "Nama Kampanye",
  promotion_group: "Grup Promosi",
  referee_list: "Daftar Wasit",
  account_verified: "Akun Terverifikasi",
  verified_date: "Tanggal Terverifikasi",
  ticket_list: "Daftar Tiket",
  vip_id: "ID Vip",
  vip_name: "Nama Vip",
  self_rebate_rate: "Tingkat Rabat Diri (%)",
  downline_rebate_rate: "Tingkat Rabat Downline (%)",
  provider: "Penyedia",
  match_id: "ID Pertandingan",
  home_team: "Tim Tuan Rumah",
  away_team: "Tim Tamu",
  home_team_new: "Tim Tuan Rumah Baru",
  away_team_new: "Tim Tamu Baru",
  updated_by: "Diperbaharui Oleh",
  updated_on: "Diperbarui Pada",
  home_score: "Skor Kandang",
  away_score: "Skor Tandang",
  home_score_new: "Skor Kandang Baru",
  away_score_new: "Skor Tandang Baru",
  team: "Tim",
  match_time: "Waktu Pertandingan",
  match_round: "Babak Pertandingan",
  home_group: "Grup Tuan Rumah",
  away_group: "Grup Tandang",
  match: "Pertandingan",
  match_status: "Status Pertandingan",
  insert: "Sisipkan",
  pin: "Sematkan",
  bet_list: "Daftar Taruhan",
  result_list: "Daftar Hasil",
  bet_id: "ID Taruhan",
  bet_home: "Taruhan Rumah",
  bet_away: "Taruhan Jauh",
  bet_on: "Taruhan Pada",
  min_deposit: "Setoran Minimum",
  min_withdrawal: "Penarikan Min",
  raise_deposit_ticket: "Naikkan Tiket Deposit",
  method: "Metode",
  one_time_depositor: "Satu Kali Penyetor",
  current_month_non_depositor: "Non Deposan Bulan Ini",
  current_month_no_login: "Bulan Ini Tidak Ada Login",
  ticket_date: "Tanggal Tiket",
  ftd_amount: "FTD Amt",
  bonus_issue: "Masalah Bonus",
  promotion_summary: "Ringkasan Promosi",
  promotion_summary_detail: "Ringkasan Promosi (Detail)",
  claim_frequency: "Frekuensi Klaim",
  provider_list: "Daftar Penyedia",
  platform_winlose: "Platform Winlose",
  adjustment_amount: "Jumlah Penyesuaian",
  referee_count: "Jumlah Wasit",
  category: " 'Kategori',",
  update_vip: "Perbarui VIP",
  update_member_profile: "Perbarui Profil Anggota",
  promotion_signup: "Pendaftaran Promosi",
  provider_bet_limit: "Batas Taruhan Penyedia",
  update_member_bet_limit: "Perbarui Batas Taruhan Anggota",
  bet_limit: "Batas Taruhan",
  sports_game: "Olahraga/Pertandingan",
  match_time: "Waktu Pertandingan",
  league_name: "Nama Liga",
  home_team_name: "Nama Tim Tuan Rumah",
  away_team_name: "Nama Tim Tamu",
  home_score: "Skor Tim Rumah",
  away_score: "Skor Tim Tamu",
  wl_status: "Status Menang Kalah",
  available_bank_account: "Rekening Bank yang Tersedia",
  group_bank_account: "Rekening Bank Grup",
  edit_bank_group: "Edit Grup Bank",
  edit_bank_account_group: "Edit Grup Rekening Bank",
  redeposit: "Deposit Ulang",
  upline: "Upline",
  downline: "Downline",
  available_promotion: "Promosi yang Tersedia",
  group_promotion: "Grup Promosi",
  edit_promotion_group: "Edit Grup Promosi",
  edit_promotion_group_norm: "Kelola Promosi Dalam Grup",
  balance_before: "Saldo Sebelum",
  balance_after: "Saldo Setelah",
  signup_count: "Jumlah Pendaftaran",
  verified_count: "Jumlah Terverifikasi",
  active_member: "Anggota Aktif",
  ftd_count: "Jumlah FTD",
  daily_summary_company: "Ringkasan Harian (Perusahaan)",
  daily_summary_operator: "Ringkasan Harian (Operator)",
  daily_summary_member: "Ringkasan Harian (Anggota)",
  daily_ledger_operator: "Buku Besar Harian (Operator)",
  adjustment_list: "Daftar Penyesuaian",
  bonus_list: "Daftar Bonus",
  ltd_date: "Tanggal LTD",
  adjustment_log: "Catatan Penyesuaian",
  get_inbox: "Dapatkan Kotak Masuk",
  is_claimed: "Sudah Diklaim",
  mix_parlay: "Mix Parlay",
  event: "Acara",
  result_changes_log: "Log Perubahan Hasil",
  view_detail: "Lihat Detail",
  total_referee: "Total Wasit",
  verified_signup: "Terverifikasi / Pendaftaran",
  ftd: "FTD | Setoran Pertama Kali",
  raw_msg: "Pesan Mentah",
  unselect_all: "Batal Pilih Semua",
  select_all: "Pilih Semua",
  edit_bet_limit: "Edit Batas Taruhan",
  provider_game_off: "Permainan Penyedia Tidak Aktif",
  provider_hot_game: "Permainan Panas Penyedia",
  game_id : "ID Permainan",
  game_list: "Daftar Permainan",
  off_list: "Daftar Tidak Aktif",
  provider_rtp: "RTP Penyedia",
  rtp: "RTP",
  signup_date: "Tanggal Pendaftaran",
  free_credit: "Kredit Gratis",
  get_rebate: "Dapatkan Rabat",
  downline_rebate: "Rebate Downline",
  game_rebate: "Rabat Permainan",
  rebate: "Rebate",
  ftd_date: "Tanggal FTD",
  provider_winlose_company: "Winlose Penyedia (Perusahaan)",
  provider_winlose_operator: "Provider Winlose (Operator)",
  report_promotion: "Laporan (Promosi)",
  already_hit: "Sudah Terkena",
  ongoing: "Sedang Berlangsung",
  members_export: "Anggota (Ekspor)",
  get_recent_deposit: "Dapatkan Setoran Terbaru",
  recent_deposit: "Setoran Terbaru",
  survey_list: "Daftar Survei",
  modified_on: "Modifikasi Aktif",
  cms: "CMS",
  announcement_banner: "Spanduk Pengumuman",
  promotion_banner: "Spanduk Promosi",
  slide_banner: "Slide Banner",
  seo_page: "Halaman SEO",
  en_title: "Judul (EN)",
  cn_title: "Judul (CN)",
  local_title: "Judul (LOKAL)",
  en_img: "Gambar (EN)",
  cn_img: "Gambar (CN)",
  local_img: "Gambar (LOKAL)",
  before_login: "Sebelum Masuk",
  after_login: "Setelah Masuk",
  en: "EN",
  move_up: "Pindah ke atas",
  move_down: "Pindah ke bawah",
  banner_type: "Jenis Banner",
  default_order: "Urutan Default",
  item_order: "Pesanan Barang",
  title: "Judul",
  banner_id: "ID Spanduk",
  order: "Pesanan",
  body: "Badan",
  en_image: "Gambar (EN)",
  local_image: "Gambar (LOKAL)",
  move: "Pindah",
  en_img_desktop: "Image Desktop (EN)",
  cn_img_desktop: "Image Desktop (CN)",
  local_img_desktop: "Image Desktop (LOKAL)",
  en_img_mobile: "Image Mobile (EN)",
  cn_img_mobile: "Image Mobile (CN)",
  local_img_mobile: "Image Mobile (LOKAL)",
  login_required: "Diperlukan Login",
  new_window_tab: "Jendela / Tab Baru",
  current_page: "Halaman Saat Ini",
  target: "Target",
  alt: "Alt",
  href: "Href",
  image_desktop: "Gambar Desktop",
  image_mobile: "Gambar Seluler",
  en_alt: "Alt (EN)",
  local_alt: "Alt (LOKAL)",
  en_href: "Href (EN)",
  local_href: "Href (LOKAL)",
  en_image_desktop: "Gambar Desktop (EN)",
  active_period: "Periode Aktif",
  en_item: "Item (EN)",
  local_item: "Item (LOKAL)",
  meta_title: "Judul Meta",
  meta_keywords: "Kata Kunci Meta",
  meta_url: "Meta URL",
  meta_canonical: "Meta Canonical",
  meta_author: "Meta Penulis",
  meta_publisher: "Meta Penerbit",
  meta_lang: "Meta Lang",
  meta_desc: "Meta Deskripsi",
  meta_image: "Meta Gambar",
  page: "Halaman",
  item: "Item",
  remove_desktop_image: "Hapus Gambar Desktop",
  remove_mobile_image: "Hapus Gambar Seluler",
  page_name: "Nama Halaman",
  login_date: "Tanggal Masuk",
  ftd_amount_min: "Min. Jumlah FTD",
  ftd_amount_max: "Jumlah FTD Maks.",
  fl_provider_code: "Penyedia Peluncuran Pertama",
  fl_game_id: "ID Game Peluncuran Pertama",
  fl_game_name: "Nama Game Peluncuran Pertama",
  no_deposit: "Tanpa Deposit",
  no_login: "Tidak Ada Login",
  top_deposit: "Setoran Tertinggi",
  top_withdrawal: "Penarikan Tertinggi",
  top_promotion: "Promosi Teratas",
  outstanding_balance: "Saldo Terhutang",
  last_update_time: "Waktu Pembaruan Terakhir",
  trace: "Lacak",
  trace_outstanding: "Lacak Saldo Terhutang",
  outstanding: "Outstanding",
  clear_outstanding: "Hapus Saldo Terhutang",
  meta_image_url: "Meta Image Url",
  member_bonus: "Bonus Anggota",
  delete_after_bonus: "Hapus Setelah Bonus",
  crm_list: "Daftar CRM",
  advance_search: "Pencarian Lanjutan",
  deposit_count_from: "Jumlah Deposit Dari",
  deposit_count_to: "Jumlah Setoran Ke",
  deposit_amount_from: "Jumlah Setoran Dari",
  deposit_amount_to: "Jumlah Setoran Ke",
  min_day_no_login: "Min. Hari Tanpa Login",
  min_day_no_deposit: "Min. Hari Tidak Melakukan Deposit",
  last_login: "Login Terakhir",
  last_deposit: "Deposit Terakhir",
  phone: "Telepon",
  email: "Email",
  ip_whitelist: "Daftar Putih IP",
  ip: "IP",
  payment_option: "Opsi Pembayaran",
  payment_mode: "Mode Pembayaran",
  payment_desc: "Deskripsi Pembayaran",
  edit_provider: "Edit Penyedia",
  success: "SUKSES",
  failed: "GAGAL",
  failed_members: "Anggota yang Gagal",
  bank_member_ewallet: "Anggota Bank (E-Wallet)",
  processing: "Memproses",
  recipient_bank_id: "ID Bank Penerima",
  recipient_bank_acc_no: "Nomor Rekening Bank Penerima",
  ticket_auto_withdrawal_log: "Log Tiket (Penarikan Otomatis)",
  resubmit_ticket: "Kirim ulang tiket",
  ticket_export: "Tiket (Ekspor)",
  export_deposit: "Ekspor (Deposit)",
  export_deposit_all: "Ekspor Semua (Deposit)",
  export_withdrawal: "Ekspor (Penarikan)",
  export_withdrawal_all: "Ekspor Semua (Penarikan)",
  export_member_all: "Ekspor Semua (Anggota)",
  processed_rejected: "Diproses (Ditolak)",
  channel: "Saluran",
  influencer: "Pemberi Pengaruh",
  ticket_id: "ID Tiket",
  recommend: "Rekomendasikan",
  sequence: "Urutan",
  progress: "Kemajuan",
  statement_info: "Info Pernyataan",
  member_info: "Info Anggota",
  slots: "Slot",
  livecasino: "Livecasino",
  sportsbook: "Sportsbook",
  cockfight: "Sabung Ayam",
  member_list: "Daftar Anggota",
  member_details: "Detail Anggota",
  operator: "Operator",
  game_balance: "Saldo Permainan",
  claim_limit: "Batas Klaim",
  max_withdraw_multiple: "Jumlah Maksimal Penarikan",
  login_count: "Jumlah Login",
  ip_info: "Info IP",
  payment_gateway: "Gerbang Pembayaran",
  min_limit: "Batas Min",
  max_limit: "Batas Maks",
  unique_member_count: "Jumlah Anggota Unik",
  total: "Total",
  success_rate: "Tingkat Keberhasilan",
  rebate_summary: "Ringkasan Rabat",
  rebate_summary_daily: "Ringkasan Rabat Harian",
  rebate_member: "Anggota Rabat",
  self: "Diri Sendiri",
  system_balance: "Saldo Sistem",
  rejected_onload: "Ditolak (Onload)",
  no_bonus: "Tidak Ada Bonus",
  review_audit_ticket: "Tinjau & Tiket Audit",
  audit_ticket: "Tiket Audit",
  review_ticket: "Tinjau Tiket",
  edit_promotion_group_norm_seq: "Kelola Urutan Promosi Dalam Grup",
  bank_provider: "Penyedia Bank",
  member_custom_vip: "Vip Khusus Anggota",
  unlock: "Buka Kunci",
  signup_bonus: "Bonus Pendaftaran",
  global_setting_affiliate: "Pengaturan Global (Afiliasi)",
  carry_over: "Carry Over",
  comm_sports: "Komisi (Olahraga)",
  comm_slots: "Komisi (Slot)",
  comm_livecasino: "Komisi (Livecasino)",
  comm_cockfight: "Komisi (Sabung Ayam)",
  comm_others: "Komisi (Lainnya)",
  update_comm: "Perbarui Komisi",
  update_carry_over: "Perbarui Carry Over",
  settlement_type: "Jenis Penyelesaian",
  ewallet: "E-Wallet",
  withdrawal_list: "Daftar Penarikan",
  audit_withdrawal: "Penarikan Audit",
  daily_withdrawal: "Penarikan Harian",
  adjustment_log_affiliate: "Log Penyesuaian",
  daily_statement_affiliate: "Laporan Harian (Afiliasi)",
  adjustment_list_affiliate: "Daftar Penyesuaian (Afiliasi)",
  earning: "Penghasilan",
  earning_total: "Total Penghasilan",
  cost_total: "Total Biaya",
  pnl: "P&L",
  deposit_bonus: "Bonus Deposit",
  wl_sports: "MenangKalah (Olahraga)",
  wl_slots: "MenangKalah (Slot)",
  wl_livecasino: "MenangKalah (Livecasino)",
  to_cockfight: "Perputaran (Sabung Ayam)",
  wl_others: "MenangKalah (Lainnya)",
  pct_platform: "Persentase (Platform)",
  pct_sports: "Persentase (Olahraga)",
  pct_slots: "Persentase (Slot)",
  pct_livecasino: "Persentase (Livecasino)",
  pct_cockfight: "Persentase (Sabung Ayam)",
  pct_others: "Persentase (Lainnya)",
  earning_sports: "Penghasilan (Olahraga)",
  earning_slots: "Penghasilan (Slot)",
  earning_livecasino: "Penghasilan (Livecasino)",
  earning_cockfight: "Penghasilan (Sabung Ayam)",
  earning_others: "Penghasilan (Lainnya)",
  cost_deposit_bonus: "Bonus Setoran Biaya",
  cost_sports: "Biaya (Olahraga)",
  cost_slots: "Biaya (Slot)",
  cost_livecasino: "Biaya (Livecasino)",
  cost_cockfight: "Biaya (Sabung Ayam)",
  cost_others: "Biaya (Lainnya)",
  review_affiliate_ticket: "Tinjau Tiket Afiliasi",
  audit_affiliate_ticket: "Audit Tiket Afiliasi",
  turnover_downline: "Omset (Downline)",
  valid_turnover_downline: "Omset (Downline) yang valid",
  winlose_downline: "MenangKalah (Downline)",
  bet_count_downline: "Jumlah Taruhan (Downline)",
  turnover_member: "Omset (Anggota)",
  valid_turnover_member: "Omset Valid (Anggota)",
  winlose_member: "MenangKalah (Anggota)",
  bet_count_member: "Jumlah Taruhan (Anggota)",
  dashboard_affiliate: "Dasbor (Afiliasi)",
  total_agent: "Total Agen",
  top_turnover: "Omset Tertinggi",
  daily_deposit: "Setoran Harian",
  bonus_count: "Jumlah Bonus",
  deposit_amount_downline: "Jumlah Setoran (Downline)",
  deposit_count_downline: "Jumlah Setoran (Downline)",
  bonus_amount_downline: "Jumlah Bonus (Downline)",
  bonus_count_downline: "Jumlah Bonus (Downline)",
  deposit_amount_member: "Jumlah Deposit (Anggota)",
  deposit_count_member: "Jumlah Deposit (Anggota)",
  bonus_amount_member: "Jumlah Bonus (Anggota)",
  bonus_count_member: "Jumlah Bonus (Anggota)",
  verified: "Terverifikasi",
  round_id: "ID Ronde",
  unfinish_round: "Putaran Belum Selesai",
  smartico_bonus_report: "Laporan Bonus Smartico",
  unclaimed_amount: "Jumlah yang Belum Diklaim",
  claimed_amount: "Jumlah yang Diklaim",
  unclaimed_count: "Jumlah yang Tidak Diklaim",
  claimed_count: "Jumlah yang Diklaim",
  submit_time: "Tanggal Dibuat",
  deposit_time: "Tanggal Modifikasi",
  player_funds: "Tiket",
  funds_list: "Daftar Tiket",
  daifu_list_auto_withdrawal: "Daftar Tiket (Penarikan Otomatis)",
  btn_href: "Referensi Tombol",
  btn_text: "Teks Tombol",
  recent_inbox_claim: "Klaim Kotak Masuk Terbaru",
  raise_deposit_ticket_gateway: "Naikkan Tiket Deposit (Gateway)",
  gateway_acc: "Akun Gateway",
  provider_winlose_member: "Provider Winlose (Anggota)",
  review_by: "Tinjau Oleh",
  daifu_list_auto_withdrawal_export: "Ekspor Tiket (Penarikan Otomatis)",
  retention: "Retenton",
  current_month_active_user: "Pengguna Aktif Bulan Ini",
  current_month_active: "Pengguna Aktif Bulan Ini",
  first_month: "Bulan Pertama",
  fmwinlose: "FMMenang Kalah",
  fmdeposit_amount: "Jumlah Deposit FM",
  cohort: "Kelompok",
  promotion_withdrawal_summary: "Ringkasan Penarikan Promosi",
  unique_player: "Pemain Unik",
  year: "Tahun | Tahun",
  audit_time_modified: "Tanggal Modifikasi",
  audit_time_created: "Tanggal Dibuat",
  approve_time: "Tanggal Modifikasi",
  unique_login_count: "Jumlah Login Unik",
  unique_withdrawal_count: "Jumlah Penarikan Unik",
  second_deposit_count: "Jumlah Deposit Kedua",
  unique_login: "Login Unik",
  unique_withdrawal: "Penarikan Unik",
  second_deposit: "Deposit Kedua",
  deposit_withdrawal_different: "Penarikan Deposit Berbeda",
  ngr: "NGR",
  audit_list: "Daftar Audit",
  rollback_count: "Jumlah Rollback",
  rejected_ticket_id: "ID Tiket Ditolak",
  rollback: "Rollback",
  recipient_bank_acc_holder: "Pemegang Rekening Bank Penerima",
  reject_date: "Tanggal Tolak",
  processing_date: "Tanggal Pemrosesan",
  manual_approve: "Setujui (Manual)",
  pending_review_funds: "Tiket Tertunda & Tinjau",
  table_id: "ID Tabel",
  member_label: "Label Anggota",
  label_name: "Nama Label",
  label: "Label",
  available_label: "Label yang Tersedia",
  bank_default_sender: "Pengirim Default Bank",
  amount_limit: "Batas Jumlah",
  bank_type: "Jenis Bank",
  bank_desc: "Keterangan Bank",
  iframe: "Iframe",
  iframe_url: "URL Iframe",
  exchange_rate: "Nilai Tukar",
  rate: "Nilai",
  rate_php: "Nilai PHP",
  ticket_withdrawal_rollback: "Penarikan Kembali Penarikan Tiket",
  smartico_bonus_report_expired: "Laporan Bonus Smartico (Kedaluwarsa)",
  reward_type: "Jenis Hadiah",
  turnover_rebate: "Rabat Omset",
  turnover_rebate_1: "Tingkat VIP",
  turnover_rebate_2: "Tingkat Turnover",
  vip_cycle_day: "Hari Siklus VIP",
  vip_maintain_deposit: "VIP Mempertahankan Deposit",
  vip_maintain_turnover: "VIP Mempertahankan Penarikan",
  is_addon: "Apakah Addon",
  no_reward: "Tidak ada hadiah",
  cash: "Uang Tunai",
  cs: "Layanan Pelanggan",
  social_platform: "Platform Sosial",
  edit_vip: "Edit VIP",
  edit_vip_provider: "Edit Penyedia VIP",
  turnover_tier: "Tingkat Omset",
  rebate_rate: "Tingkat Rabat",
  edit_turnover_tier: "Edit Tingkat Omset",
  delete_turnover_tier: "Hapus Tingkat Omset",
  vip_log: "Catatan VIP",
  member_full_record: "Catatan Lengkap Anggota",
  level: "level | lvl",
  before: "Sebelum",
  after: "Setelah",
  maintain: "Pertahankan",
  actual_rebate: "Rabat Aktual",
  rounded_rebate: "Rabat Bulat",
  rebate_list: "Daftar Rabat",
  rebate_mode: "Mode Rabat",
  inbox_id: "ID Kotak Masuk",
  rebate_type: "Jenis Rabat",
  rebate_list_member: "Daftar Rabat (Anggota)",
  promotion_type: "Jenis Promosi",
  bonus_rate_1: "Rate 1 (%)",
  bonus_rate_2: "Rate 2 (%)",
  bonus_rate_3: "Rate 3 (%)",
  bonus_rate_4: "Rate 4 (%)",
  bonus_rate_5: "Tarif 5 (%)",
  bonus_rate_6: "Tingkat 6 (%)",
  bonus_rate_7: "Tingkat 7 (%)",
  bonus_rate_8: "Tingkat 8 (%)",
  bonus_rate_9: "Tingkat 9 (%)",
  bonus_rate_10: "Nilai 10 (%)",
  delete_all: "Hapus Semua",
  rescue_fund: "Dana Penyelamatan",
  up: "Naik",
  down: "Turun",
  rate_percent: "Rate %",
  rescue_fund_payout: "Pembayaran Dana Penyelamatan",
  cycle: "Siklus",
  actual_amount: "Jumlah Aktual",
  rounded_amount: "Jumlah Pembulatan",
  payout_list: "Daftar Pembayaran",
  rescue_id: "ID Penyelamatan",
  rescue_name: "Nama Penyelamatan",
  min_lose: "Kalah Min",
  max_payout: "Pembayaran Maks",
  payout_method: "Metode Pembayaran",
  target_group: "Kelompok Target",
  member_vip_id: "ID VIP Anggota",
  member_vip_name: "Nama VIP Anggota",
  member_vip_level: "Level VIP Anggota",
  rescue_vip_id: "ID VIP Penyelamatan",
  rescue_vip_name: "Nama VIP Penyelamatan",
  rescue_vip_level: "Level VIP Penyelamatan",
  daily: "Harian",
  weekly: "Mingguan",
  monthly: "Bulanan",
  edit_batch: "Edit Batch",
  current_level: "Level Saat Ini",
  next_level: "Level Berikutnya",
  rescue: "Penyelamatan",
  bet_value: "Nilai Taruhan",
  line_bet: "Taruhan Baris",
  total_round: "Total Putaran",
  audit_by: "Audit Oleh",
  possible_next_level: "Kemungkinan Tingkat Berikutnya",
  maintain_deposit: "Pertahankan Deposit",
  maintain_turnover: "Pertahankan Turnover",
  starting_deposit: "Memulai Deposit",
  starting_turnover: "Memulai Omset",
  cycle_deposit: "Setoran Siklus",
  cycle_turnover: "Perputaran Siklus",
  vip_list: "Daftar VIP",
  up_maintain: "Naik Pertahankan",
  down_lowest: "Turun Terendah",
  manual: "Manual",
  daily_winlose_game: "Winlose Harian (Permainan)",
  action_affiliate: "Aksi (Afiliasi)",
  actionaff: "Aksi (Afiliasi)",
  onload: "Memuat",
  update_status: "Perbarui Status",
  role_settings: "Pengaturan Peran",
  customer_services: "Layanan Pelanggan",
  marketing: "Pemasaran",
  finance: "Keuangan",
  payment: "Pembayaran",
  risk_management: "Manajemen Risiko",
  winlose_turnover: "WL/TO",
  pt_percentage: "PT %",
  pt: "PT",
  wallet_history: "Riwayat Dompet",
  ticket_amount: "Jumlah Tiket",
  label_colour: "Warna label",
  ignore_risk: "Abaikan Risiko",
  permitted_amount: "Jumlah yang Diizinkan",
  all_pending_ticket: "Semua Tiket Tertunda",
  rescue_fund_summary: "Ringkasan Dana Penyelamatan",
  rescue_fund_summary_daily: "Ringkasan Dana Penyelamatan Harian",
  rescue_fund_member: "Anggota Dana Penyelamatan",
  master: "Master",
  account_type: "Jenis Akun",
  freeze: "Bekukan",
  domain_member_setup: "Pengaturan Domain Situs Anggota",
  domain: "Domain",
  domain_list: "Daftar Domain",
  domain_application: "Aplikasi Domain",
  domain_status: "Status Domain",
  domain_group: "Grup Domain",
  operator_id: "ID Operator",
  domain_type: "Jenis Domain",
  taken_on: "Diambil",
  module: "Modul",
  template: "Template",
  custom: "Kustom",
  default: "Default",
  payment_provider: "Penyedia Pembayaran",
  payment: "Pembayaran",
  deactivate: "Tidak Aktif",
  buy_on_behalf: "Beli Atas Nama",
  name_server: "Server Nama",
  server_account: "Akun Server",
  service_provider: "Penyedia Layanan",
  process: "Proses",
  provider_operator: "Operator Penyedia",
  bet_limit_member: "@",
  bet_limit_provider: "@",
  global: "Pengaturan Global",
  second_id: "ID Kedua",
  unverified: "Belum diverifikasi",
  operator_list: "Daftar Operator",
  available_operator_list: "Daftar Operator yang Tersedia",
  CN: "CN",
  pt_cockfight: "PT Sabung Ayam (%)",
  pt_livecasino: "PT Kasino Hewan (%)",
  pt_others: "Lainnya PT (%)",
  pt_slots: "Slot PT (%)",
  pt_sports: "Sportsbook PT (%)",
  pt_gateway: "PT Gerbang Pembayaran (%)",
  pt_affiliate: "Biaya Platform Afiliasi (%)",
  recipient_bank: "Bank Penerima",
  payment_channel: "Saluran Pembayaran",
  deposit_type: "Jenis Setoran",
  security_fund: "Dana Keamanan",
  topup_security_fund: "Isi Ulang Dana Keamanan",
  adjust_balance_op: "Sesuaikan Dompet Operator",
  adjust_security_deposit_op: "Sesuaikan Dana Keamanan Operator",
  marquee: "Tenda",
  marquee_content: "Konten Marquee",
  edit_marquee: "Edit Marquee",
  domain_available: "Domain Tersedia",
  payment_provider_co: "@:ui.payment_provider (@:ui.company)",
  payment_provider_gb: "@:ui.payment_provider (@:ui.global)",
  payment_option_co: "@:ui.payment_option (@:ui.company)",
  payment_option_gb: "@:ui.payment_option (@:ui.global)",
  bank_company: "@:ui.bank @:ui.company",
  daily_withdrawal_frequency: "Frekuensi Penarikan Harian",
  domain_price: "Harga Domain",
  maintenance: "Pemeliharaan",
  max_withdrawal: "Penarikan Maksimum",
  min_balance: "Saldo Minimum",
  platform_fee: "Biaya Platform",
  affiliate_report: "Laporan Afiliasi",
  winlose_withdrawal_chart: "Grafik Kemenangan / Penarikan Dana",
  deposit_turnover_chart: "Grafik Setoran / Omset Valid",
  cost: "Biaya",
  cash_balance: "Saldo Kas",
  security_deposit: "Dana Jaminan",
  copy_success: "Berhasil menyalin!",
  copy_failed: "Penyalinan gagal!",
  your_website: "Situs Web Anda",
  correction_promo: "Koreksi (Promosi)",
  others: "Lainnya",
  total_earning: "Total Penghasilan",
  total_cost: "Total Biaya",
  cost_breakdown: "Perincian Biaya",
  is_proccesed: "Sedang Diproses",
  audit_log: "Catatan Audit",
  view: "Lihat",
  email_otp: "Email OTP",
  request_otp: "Minta OTP",
  price: "Harga",
  package_level: "Tingkat Paket",
  bo_right: "BO Benar",
  english: "Bahasa Inggris",
  simplified_chinese: "Bahasa Mandarin (CN)",
  traditional_chinese: "Bahasa Mandarin (TW)",
  philippine: "Filipina",
  thai: "Thailand",
  vietnamese: "Bahasa Vietnam",
  indonesian: "Indonesia",
  myanmar: "Myanmar",
  japanese: "Jepang",
  korean: "Bahasa Korea",
  package_type: "Jenis Paket",
  full_back_office_access_right: "Hak Akses Back Office Penuh",
  read_only_back_office: "Back Office Hanya Baca",
  language: "Bahasa",
  lang_code: "Kode Bahasa",
  description: "Deskripsi",
  provider_type: "Jenis Penyedia",
  logo: "Logo",
  provider_game: "Permainan Penyedia",
  payment_code: "Kode Gerbang Pembayaran",
  payment_name: "Nama Gerbang Pembayaran",
  recommended: "Direkomendasikan",
  theme_provider: "Penyedia Tema",
  theme_content: "Konten Tema",
  content_id: "ID Konten",
  content_desc: "Deskripsi Konten",
  theme_content_position: "Posisi Konten Tema",
  theme: "Tema",
  theme_code: "Kode Tema",
  theme_name: "Nama Tema",
  color: "Warna",
  position: "Posisi",
  user_id: "ID Pengguna",
  site_name: "Nama Situs",
  step: "Langkah",
  theme_color: "Warna Tema",
  pending_payment: "Pembayaran Tertunda",
  timeout: "Batas Waktu",
  purchased: "Dibeli",
  pending_setup: "Pengaturan Tertunda",
  completed: "Selesai",
  verified_on: "Terverifikasi Aktif",
  email_verified_on: "Email Terverifikasi Aktif",
  profile: "Profil",
  not_verified: "Tidak Terverifikasi",
  attempt_block: "Blokir Percobaan",
  company_block: "Blokir Perusahaan",
  phone_tac: "OTP Telepon",
  email_tac: "OTP Email",
  tac: "OTP",
  tac_expiry: "Masa Berlaku OTP",
  theme_purchased: "Tema yang Dibeli",
  total_purchased: "Total Pembelian",
  purchased_date: "Tanggal Pembelian",
  purchase: "Pembelian",
  top_purchase: "Pembelian Teratas (Troli)",
  user_count: "Jumlah Pengguna",
  purchase_count: "Jumlah Pembelian",
  active_site: "Situs Aktif",
  total_site: "Total Situs",
  content_setup: "Pengaturan Konten",
  site_list: "Daftar Situs",
  site_id: "ID Situs",
  draft_version: "Versi Draf",
  prod_version: "Prod. Versi",
  production_version: "Versi Produksi",
  info: "Info",
  setting: "Pengaturan",
  domain: "Domain",
  site_info: "Info Situs",
  site: "Situs",
  menu: "Menu",
  game_menu: "Menu Permainan",
  special_menu: "Menu Khusus",
  setting_menu: "Menu Pengaturan",
  error: "Kesalahan",
  sync_all: "Sinkronisasi Semua",
  site_details: "Detail Situs",
  old_value: "Nilai Lama",
  new_value: "Nilai Baru",
  theme_content_group: "Grup Konten Tema",
  content_group: "Grup Konten",
  content_group_desc: "Deskripsi Grup Konten",
  parent_content_id: "ID Konten Induk",
  bo_default_domain: "Domain Default BO",
  domain_id: "ID Domain",
  deactive: "Nonaktif",
  site_sync: "Sinkronisasi Situs",
  upload: "Unggah",
  comingSoon: "Segera Hadir",
  site_edit: "Edit Situs",
  profile_setting: "Pengaturan Profil",
  bank: "Bank",
  company: "Perusahaan",
  own: "SENDIRI",
  operator_setting: "Pengaturan Operator",
  external_id: "ID Eksternal",
  ticket: "Tiket",
  bank_owner: "Pemilik Bank",
  exchanged_currency: "Mata Uang yang Ditukar",
  company_bank_owner: "Pemilik Bank Perusahaan",
  ticketoperator: "Tiket (Operator)",
  ticket_list_member: "Daftar Tiket (Anggota)",
  ticket_list_operator: "Daftar Tiket (Operator)",
  pending_ticket_list_operator: "Daftar Tiket Tertunda (Operator)",
  site_recreate: "Buat Ulang Situs",
  game_name_exclude: "Kecualikan Nama Game",
  tab: "Tab",
  about_us: "Tentang Kami",
  privacy_policy: "Kebijakan Privasi",
  responsible_gaming: "Permainan yang Bertanggung Jawab",
  banking: "Perbankan",
  faqs: "PERTANYAAN UMUM",
  advertisement: "Iklan",
  domain_op: "Domain (Operator)",
  px_pixel_id: "PX Pixel ID",
  px_token: "Token PX",
  af_dev_key: "Af Dev Key",
  af_apps_id: "ID Aplikasi Af",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "PP AID",
  gtm_id: "ID GTM",
  service_provider_url: "URL Penyedia Layanan",
  script_inject: "Suntikan Skrip",
  head_script: "Skrip Kepala",
  body_script: "Naskah Tubuh",
  ads_id: "ID Iklan",
  min_deposit_operator: "Min. Operator Deposit",
  member_detail: "Detail Anggota",
  memberreport: "Laporan Anggota",
  member_log: "Log Anggota",
  dashboard_admin: "Dasbor (Admin)",
  general: "Umum",
  top_theme: "Tema Teratas",
  hot_game: "Permainan Populer",
  hot_list: "Daftar Populer",
  total_winlose_by_category: "Total Kemenangan Berdasarkan Kategori",
  new_game: "Permainan Baru",
  popular_game: "Permainan Populer",
  featured_game: "Permainan Unggulan",
  new_list: "Daftar Baru",
  popular_list: "Daftar Populer",
  featured_list: "Daftar Unggulan",
  provider_new_game: "Game Baru Penyedia",
  provider_popular_game: "Game Populer Penyedia",
  provider_featured_game: "Game Unggulan Penyedia",
  pending_master_list: "Daftar Master Tertunda",
  website: "Situs Web",
  site_customization: "Kustomisasi Situs",
  export_all: "Ekspor semua",
  export_one: "Ekspor (Halaman Saat Ini)",
  daily_ledger: "Buku Besar Harian",
  daily_ledger_member: "Buku Besar Harian (Anggota)",
  promotion_signup_unused: "Promosi Pendaftaran yang tidak digunakan",
  promotion_signup_ongoing: "Promosi Pendaftaran yang Sedang Berlangsung",
  promotion_signup_winlose: "Promosi Pendaftaran Winlose",
  promotion_signup_winlose_operator: "Promosi Pendaftaran Winlose (Operator)",
  promotion_signup_winlose_member: "Promosi Pendaftaran Winlose (Anggota)",
  total_player_balance: "Total Saldo Pemain",
  search_all: "Cari Semua",
  gateway_name: "Nama Gateway",
  mbsetting: "Pengaturan",
  todays_highlights: "Sorotan Hari Ini",
  deposit_player: "Pemain Deposit",
  withdrawal_player: "Pemain Penarikan",
  kill_rate: "Tingkat Pembunuhan",
  login_player: "Pemain Masuk",

  operation_management: "Operasi",
  game_management: "Permainan",
  member_management: "Anggota",
  affiliate_management: "Afiliasi",
  promotion_management: "Promosi",
  risk_management: "Manajemen Risiko",
  system_settings: "Pengaturan Sistem",
  mbcampaign: "Kampanye",
  promo_allday: "Sepanjang Hari",
  promo_daily: "Harian",
  promo_daily_first_deposit: "Setoran Pertama Harian",
  promo_deposit_monthly: "Jumlah Setoran Bulanan",
  promo_deposit_signup: "Jumlah Setoran Pendaftaran",
  promo_deposit_weekly: "Hitungan Setoran Mingguan",
  promo_newbie: "Pemula",
  promo_once: "Sekali",
  dd_review: "Tinjau",
  game_provider_management: "Penyedia",
  exchanged_amount: "Jumlah yang Ditukar",
  operator_summary: "Ringkasan Operator",
  business_id: "ID Bisnis",
  game_name_exclude_log: "Log Pengecualian Nama Game",
  cn: "CN",
  local: "LOKAL",
  taken: "Diambil",
  receiver_bank: "Bank Penerima",
  receiver_bank_acc_no: "Nomor Akuntasi Bank Penerima",
  receiver_bank_acc_holder: "Pemegang Rekening Bank Penerima",
  add_balance: "Tambah Saldo",
  deduct_balance: "Kurangi Saldo",
  sync_site_content: "Sinkronisasi Konten Situs",
  payment_setting: "Pengaturan Pembayaran",
  payment_own: "SENDIRI",
  payment_global: "GLOBAL",
  livechat: "LiveChat",
  chat_id: "Kunci Lisensi LiveChat",
  chat_provider: "Penyedia LiveChat",
  account_list: "Daftar Akun",
  copy_list: "Daftar Salinan",
  access_auto_list: "Daftar Penugasan Otomatis",

  create: "Buat",
  hint: "Petunjuk",
  quickSetup: "Pengaturan Cepat",
  next: "Berikutnya",
  setUpTheme: "Atur Tema",
  checkOut: "Periksa",
  standardPackage: "Paket Standar",
  siteName: "Nama Situs",
  information: "Informasi",
  useThisTemplate: "Gunakan Template Ini",
  orderTimeAndDate: "Waktu & Tanggal Pemesanan",
  packageLimit: "Batas Paket",
  summary: "Ringkasan",
  createOperatorAccount: "Buat Akun Operator",
  operatorId: "ID Operator",
  operatorPwd: "Kata Sandi Operator",
  click: "Klik",
  toLogin: "untuk Masuk",
  new_website: "Situs Baru",
  new_website_list: "Daftar Situs Baru",
  website_id: "ID Situs",
  cart_list: "Daftar Keranjang",
  cart: "Keranjang",
  cart_id: "ID Keranjang",
  operator_information: "Informasi Operator",
  bo_link: "Tautan Backend",

  daily_summary_sms: "Ringkasan SMS Harian",
  daily_summary_sms_operator: "Ringkasan SMS Harian Operator",
  daily_summary_sms_operator_detail: "Detail Ringkasan SMS Harian Operator",
  sms_count: "Jumlah SMS",

  provider_winlose_operator_pt: "Provider Winlose (Operator PT)",
  pt_on: "PT On",
  share_operator: "Bagikan Operator",
  share_company: "Bagikan Perusahaan",

  token_log: "Catatan Token",
  action_type: "Jenis Tindakan",
  
  template_code: "Kode Template",
  template_name: "Nama Template",
  mini_game: "Permainan Mini",
  max_game_reward: "Hadiah Maksimum Permainan",
  max_chance_per_day: "Kesempatan Maksimum per Hari",
  is_recurring_chance: "Berulang",
  token_request: "Token",
  enabled: "Diaktifkan",
  disabled: "Dinonaktifkan",
  unlimited: "Tak Terbatas",
  max_chance_unlimited: "Kesempatan Maksimum per Hari Tak Terbatas",
  mini_game_template: "Template Permainan Mini",
  reward_code: "Kode Hadiah",
  reward_name: "Nama Hadiah",
  reward_description: "Deskripsi Hadiah",
  reward_probability: "Probabilitas Hadiah",
  total_game: "Total Permainan",
  total_played_mini_game: "Total Permainan Mini yang Dimainkan",
  total_played_mini_game_detail: "Rincian Total Permainan Mini yang Dimainkan",
  total_played_mini_game_detail_operator: "Rincian Total Permainan Mini yang Dimainkan (Operator)",
  daily_pnl_operator: "P&L Harian (Operator)",
  token: "Token",
  gamify: "Gamifikasi",
  token_1: "Token 1",
  token_2: "Token 2",
  token_3: "Token 3",
  token_4: "Token 4",
  token_5: "Token 5",
  token_6: "Token 6",
  token_7: "Token 7",
  cash_1: "Tunai 1",
  cash_2: "Tunai 2",
  cash_3: "Tunai 3",
  cash_4: "Tunai 4",
  cash_5: "Tunai 5",
  cash_6: "Tunai 6",
  cash_7: "Tunai 7",
  daily_login: "Check-in Harian (Login Harian)",
  daily_login_update: "Pembaruan Check-in Harian (Login Harian)",
  game_result_reward: "Hadiah Hasil Permainan",
  current_streak: "Rekor Beruntun Saat Ini",
  login_streak: "Rekor Login Beruntun",
  total_token: "Total Token",
  total_mini_game_token_used: "Total Token Mini Game yang Digunakan",
  total_mini_game_token_used_detail: "Detail Total Token Mini Game yang Digunakan",
  total_mini_game_token_used_detail_operator: "Detail Total Token Mini Game yang Digunakan (Operator)",
  total_reward: "Total Hadiah",
  total_mini_game_reward: "Total Hadiah Mini Game",
  total_mini_game_reward_detail: "Detail Total Hadiah Mini Game",
  total_mini_game_reward_detail_operator: "Detail Total Hadiah Mini Game (Operator)",
  token_balance: "Saldo Token",
  free_game_token: "Token Game Gratis",
  bo_url: "URL Backoffice",
  copied: "Disalin",

  callback: "Callback",
  api: "API",
  prefix: "Prefiks",
  delimiter: "Pemisah",

  url_callback_deposit: "URL Callback Deposit",
  url_callback_withdrawal: "URL Callback Penarikan",
  url_callback_affiliate: "URL Callback Afiliasi",
  url_api_deposit: "URL Callback Deposit (API)",
  url_api_withdrawal: "URL Callback Penarikan (API)",
  url_api_balance: "URL Callback Saldo (API)",
  prefix_deposit: "Prefiks Deposit",
  prefix_withdrawal: "Prefiks Penarikan",
  prefix_affiliate: "Prefiks Afiliasi",
  prefix_delimiter: "Pemisah Prefiks",

  merchant: "Pedagang",
  app_id: "ID Aplikasi",
  secret_key: "Kunci Rahasia",
  deposit_secret_key: "Kunci Rahasia Deposit",
  withdrawal_secret_key: "Kunci Rahasia Penarikan",
  partners: "Mitra",
  partner_name: "Nama Mitra",
  win: "Win",
  manifest: "Manifest",
  crop: "Pangkas",
  cropImage: "Pangkas Gambar",
  api_url: "URL API",

}